export const errorTypes = {
  INVALID_FACING_MODE: {
    details: 'Facing mode not recognized',
    type: 'INVALID_FACING_MODE',
  },
  NO_STREAM: {
    details: 'Your browser does not support this feature',
    type: 'NO_STREAM',
  },
  TAKE_PHOTO_FAILURE: {
    details: 'Could not take a photo',
    type: 'TAKE_PHOTO_FAILURE',
  },
  UNSUPPORTED: {
    details: 'Your browser does not support this feature',
    type: 'UNSUPPORTED',
  },
};



// WEBPACK FOOTER //
// ./src/camera/errorTypes.js